import React, {useState} from 'react'
import ModalVideo from 'react-modal-video'

export default function Media(prop) {
    const [isOpen, setOpen] = useState(false);

    var media = "";
    if (prop.type === "video") {
        media= <div className="video-wrapper">
        <React.Fragment>
            <ModalVideo channel={prop.channel} autoplay isOpen={isOpen} videoId={prop.videoId} onClose={() => setOpen(false)} />
            <button className="action-button" onClick={() => setOpen(true)}>
                <svg width={60} height={60} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M25 41.25L40 30L25 18.75V41.25ZM30 5C16.2 5 5 16.2 5 30C5 43.8 16.2 55 30 55C43.8 55 55 43.8 55 30C55 16.2 43.8 5 30 5ZM30 50C18.975 50 10 41.025 10 30C10 18.975 18.975 10 30 10C41.025 10 50 18.975 50 30C50 41.025 41.025 50 30 50Z" fill="white" />
                </svg>
            </button>
            <img src={prop.imageUrl} className='img-fluid' />
        </React.Fragment>

    </div>;
    }
    else {
        media= <img src={prop.imageUrl} className='img-fluid'/>  ;
    }
    return (
       media
    )
}
